import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthActions } from "./authSlice";

interface ScreenState {
    menuVisible: boolean;
    screenNum: number;
    activities: number;
}

const initialScreenState: ScreenState = {
    menuVisible: false,
    screenNum: 0,
    activities: 0,
};

export const screenSlice = createSlice({
    name: "screens",
    initialState: initialScreenState,
    reducers: {
        setMenuVisible: (state, action: PayloadAction<boolean>) => {
            state.menuVisible = action.payload;
        },
        setScreenNum: (state, action: PayloadAction<number>) => {
            state.screenNum = action.payload;
        },
        setActivity: state => {
            state.activities++;
        },
        finishActivity: state => {
            state.activities--;
        },
    },
    extraReducers: builder => {
        builder
            .addCase("configurations/load", state => {
                state.screenNum = 0;
            })
            .addCase(AuthActions.unauthenticated, () => initialScreenState);
    },
});

export const ScreenActions = {
    ...screenSlice.actions,
};
